module.exports = __webpack_public_path__ + "static/media/reward2.d8ebbc3b.png";